/* eslint-disable max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext, withTheme } from 'styled-components';
import { getThemeProp } from '@amtrav/themes';
import { Box, Flex } from '@rebass/grid';
import { getNavigationLogo, Text } from '@amtrav/view-components';
import SiteLogo from '../../apps/sitenav/components/SiteLogo';

const MainBackground = styled.div`
  position: relative;
  margin: 40px;
  width: 514px;
  height: 85vh;
  background: url('/images/theme-cava/images/woman-relaxing-by-a-window.jpg') no-repeat center center;
  background-size: cover;
  background-color: white; /* Fallback color */
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* Ensures content is above the overlay */
  position: relative;
  z-index: 1;

  /* Black overlay behind content */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2); /* 20% opacity black */
    border-radius: 32px;
    z-index: -1; /* Moves the overlay behind the content */
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: 100%;
  }

  @media (max-width: 1280px) {
    width: 430px;
  }
`;

const LogoContainer = styled(Flex)`
  position: absolute;
  top: 20px;
  left: 40px;

  svg {
    filter: invert(1) brightness(1000%) contrast(1000%);
  }
`;

const Sidebar = ({ marketingContent, subheadMessage, homeUrl }) => {
  const theme = useContext(ThemeContext);

  const NavLogo = withTheme(({ theme }) => {
    //
    return getNavigationLogo(theme.siteNavigation.navLogo);
  });
  return (
    <MainBackground>
      <LogoContainer width="40%">
        <NavLogo />
      </LogoContainer>
      <Flex justifyContent="center" alignItems="center" flexDirection="column" mt={4}>
        <Text size={33} colorToken="white" weight="500">
          <div>It's the power of being there,</div>
        </Text>
        <Text size={33} colorToken="white" weight="500">
          <div>made powerfully simple.</div>
        </Text>
      </Flex>
    </MainBackground>
  );
};
export default Sidebar;

Sidebar.propTypes = {
  // the subheadMessage is not a string so we can add
  // line breaks to the text if needed
  subheadMessage: PropTypes.element.isRequired,
  marketingContent: PropTypes.element,
  homeUrl: PropTypes.string,
};
